import { StyleType, CssColor } from '@wix/editor-platform-ooi-metadata-resolver';
import { borderWidth, color, cornerRadius, padding, titleFont } from './tabsStylesParams';

const ACTIVE_COLOR = { wixColorName: 'color-8', preset: CssColor.WstLinksAndActionsColor };
const INACTIVE_TEXT_COLOR = { wixColorName: 'color-5', preset: CssColor.WstParagraph2Color };
const INACTIVE_BORDER_COLOR = { wixColorName: 'color-5', preset: CssColor.WstParagraph2Color, opacity: 0.1 };
const BACKGROUND_COLOR = { wixColorName: 'color-1', preset: CssColor.WstPrimaryBackgroundColor };

export const variantToggleStylesParams = {
  tabSwitcherPaddingX: padding('tabSwitcherPaddingX', 8),
  tabSwitcherPaddingY: padding('tabSwitcherPaddingY', 9),

  tabSwitcherActiveFont: titleFont('tabSwitcherActiveFont'),
  tabSwitcherActiveTextColor: color({
    key: 'tabSwitcherActiveTextColor',
    type: StyleType.color,
    ...ACTIVE_COLOR,
  }),
  tabSwitcherActiveBg: color({
    key: 'tabSwitcherActiveBg',
    type: StyleType.color,
    ...BACKGROUND_COLOR,
  }),
  tabSwitcherActiveRadiusTopLeft: cornerRadius('tabSwitcherActiveRadiusTopLeft', 10),
  tabSwitcherActiveRadiusTopRight: cornerRadius('tabSwitcherActiveRadiusTopRight', 10),
  tabSwitcherActiveRadiusBottomLeft: cornerRadius('tabSwitcherActiveRadiusBottomLeft', 10),
  tabSwitcherActiveRadiusBottomRight: cornerRadius('tabSwitcherActiveRadiusBottomRight', 10),
  tabSwitcherActiveBorderWidth: borderWidth('tabSwitcherActiveBorderWidth', 2),
  tabSwitcherActiveBorderColor: color({
    key: 'tabSwitcherActiveBorderColor',
    type: StyleType.borderColor,
    ...ACTIVE_COLOR,
  }),

  tabSwitcherActiveHoverTextColor: color({
    key: 'tabSwitcherActiveHoverTextColor',
    type: StyleType.color,
    ...ACTIVE_COLOR,
  }),
  tabSwitcherActiveHoverBg: color({
    key: 'tabSwitcherActiveHoverBg',
    type: StyleType.color,
    ...BACKGROUND_COLOR,
  }),
  tabSwitcherActiveHoverBorderColor: color({
    key: 'tabSwitcherActiveHoverBorderColor',
    type: StyleType.borderColor,
    ...ACTIVE_COLOR,
  }),

  tabSwitcherInactiveFont: titleFont('tabSwitcherInactiveFont'),
  tabSwitcherInactiveTextColor: color({
    key: 'tabSwitcherInactiveTextColor',
    type: StyleType.color,
    ...INACTIVE_TEXT_COLOR,
  }),
  tabSwitcherInactiveBg: color({
    key: 'tabSwitcherInactiveBg',
    type: StyleType.color,
    ...BACKGROUND_COLOR,
  }),
  tabSwitcherInactiveRadiusTopLeft: cornerRadius('tabSwitcherInactiveRadiusTopLeft', 10),
  tabSwitcherInactiveRadiusTopRight: cornerRadius('tabSwitcherInactiveRadiusTopRight', 10),
  tabSwitcherInactiveRadiusBottomLeft: cornerRadius('tabSwitcherInactiveRadiusBottomLeft', 10),
  tabSwitcherInactiveRadiusBottomRight: cornerRadius('tabSwitcherInactiveRadiusBottomRight', 10),
  tabSwitcherInactiveBorderWidth: borderWidth('tabSwitcherInactiveBorderWidth', 1),
  tabSwitcherInactiveBorderColor: color({
    key: 'tabSwitcherInactiveBorderColor',
    type: StyleType.borderColor,
    ...INACTIVE_BORDER_COLOR,
  }),

  tabSwitcherInactiveHoverTextColor: color({
    key: 'tabSwitcherInactiveHoverTextColor',
    type: StyleType.color,
    ...INACTIVE_TEXT_COLOR,
  }),
  tabSwitcherInactiveHoverBg: color({
    key: 'tabSwitcherInactiveHoverBg',
    type: StyleType.color,
    ...BACKGROUND_COLOR,
  }),
  tabSwitcherInactiveHoverBorderColor: color({
    key: 'tabSwitcherInactiveHoverBorderColor',
    type: StyleType.borderColor,
    ...INACTIVE_BORDER_COLOR,
  }),
};
